import {Page} from './Page.js';
import {PageHome} from './PageHome.js';
import {PageLogin} from './PageLogin.js';
import {PageReservation} from "./PageReservation";
import {PageForm} from "./PageForm";
import {PageContent} from "./PageContent";

class Main
{
	constructor ()
	{
		console.log('Main');

		switch ( (Page.getBody()).attr('data-page-id') )
		{
			case 'home':
				new PageHome();
				break;
			case 'login':
				new PageLogin();
				break;
			case 'reservation':
				new PageReservation();
				break;
			case 'form':
				new PageForm();
				break;
			case 'content':
				new PageContent();
				break;

		}
	}
}

$(function () {
	new Main();
});